(() => {
  if (window.KranTeamBrevoFormsInitialized) return;
  window.KranTeamBrevoFormsInitialized = true;

  const formSelector = '[data-kt-brevo-form]';
  const turnstileWidgets = new WeakMap();
  let turnstileLoading = false;

  const renderTurnstileWidgets = () => {
    if (!window.turnstile || typeof window.turnstile.render !== 'function') return;

    document.querySelectorAll('[data-kt-turnstile]').forEach((container) => {
      if (turnstileWidgets.has(container)) return;
      try {
        const widgetId = window.turnstile.render(container, {
          sitekey: container.dataset.sitekey,
          action: container.dataset.action,
          theme: 'light',
          size: 'flexible',
        });
        turnstileWidgets.set(container, widgetId);
      } catch (_) {
        // The submit handler displays a readable error if the widget is unavailable.
      }
    });
  };

  const loadTurnstile = () => {
    if (!document.querySelector('[data-kt-turnstile]')) return;
    if (window.turnstile) {
      renderTurnstileWidgets();
      return;
    }
    if (turnstileLoading) return;
    turnstileLoading = true;

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = renderTurnstileWidgets;
    document.head.appendChild(script);
  };

  const observeTurnstileContainers = () => {
    loadTurnstile();
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) =>
        node instanceof Element && (node.matches('[data-kt-turnstile]') || node.querySelector('[data-kt-turnstile]'))
      ))) {
        loadTurnstile();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeTurnstileContainers, { once: true });
  } else {
    observeTurnstileContainers();
  }

  const statusElement = (form, attribute) => {
    const id = form.getAttribute(attribute);
    return id ? document.getElementById(id) : null;
  };

  const setStatus = (element, message, visible) => {
    if (!element) return;
    if (message) element.textContent = message;
    element.hidden = !visible;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;

    event.preventDefault();
    if (!form.reportValidity()) return;

    const success = statusElement(form, 'data-kt-success-id');
    const error = statusElement(form, 'data-kt-error-id');
    const submit = form.querySelector('[type="submit"]');
    const originalLabel = submit instanceof HTMLButtonElement ? submit.textContent : '';
    const turnstileContainer = form.querySelector('[data-kt-turnstile]');

    setStatus(success, '', false);
    setStatus(error, '', false);
    if (turnstileContainer) {
      const widgetId = turnstileWidgets.get(turnstileContainer);
      const token = widgetId !== undefined && window.turnstile
        ? window.turnstile.getResponse(widgetId)
        : '';
      if (!token) {
        setStatus(error, 'Bitte schließen Sie die Sicherheitsprüfung ab und versuchen Sie es erneut.', true);
        turnstileContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    if (submit instanceof HTMLButtonElement) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Wird gesendet …';
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });

      let payload = null;
      try {
        payload = await response.json();
      } catch (_) {
        // The generic message below is intentional when a proxy returns no JSON.
      }

      if (!response.ok || !payload || payload.ok !== true) {
        throw new Error(payload?.message || 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.');
      }

      form.reset();
      form.dispatchEvent(new Event('kt:submitted', { bubbles: true }));
      setStatus(success, payload.message || 'Vielen Dank. Ihre Anfrage wurde übermittelt.', true);
      success?.focus();

      // Only the actual contact/typeplate form counts as a LinkedIn contact.
      // Shopify appends the section ID, hence the prefix check instead of an
      // exact ID comparison. Cart quote requests intentionally do not fire it.
      if (form.id.startsWith('KranTeamContactForm-') && window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish('kranteam:contact_submitted', {
          form_id: form.id,
          provider: 'brevo',
        });
      }
    } catch (requestError) {
      const message = requestError instanceof Error
        ? requestError.message
        : 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.';
      setStatus(error, message, true);
      error?.focus();
    } finally {
      if (turnstileContainer && turnstileContainer.isConnected && window.turnstile) {
        const widgetId = turnstileWidgets.get(turnstileContainer);
        if (widgetId !== undefined) window.turnstile.reset(widgetId);
      }
      if (submit instanceof HTMLButtonElement) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submit.textContent = originalLabel;
      }
    }
  });
})();
